import { NODE_TYPES } from './nodes/nodeConstants';

export enum ChannelType {
  Email = 'Email',
  Push = 'Push',
  SMS = 'SMS',
}

/* A map of the channel types to the node types, and reverse */
export const ChannelNodeTypeMap: Record<string, string> = {
  [NODE_TYPES.SEND_EMAIL]: ChannelType.Email,
  [NODE_TYPES.SEND_PUSH]: ChannelType.Push,
  [NODE_TYPES.SEND_SMS]: ChannelType.SMS,
  [ChannelType.Email]: NODE_TYPES.SEND_EMAIL,
  [ChannelType.Push]: NODE_TYPES.SEND_PUSH,
  [ChannelType.SMS]: NODE_TYPES.SEND_SMS,
};

export type ChannelNodeTypeMap = (typeof ChannelNodeTypeMap)[keyof typeof ChannelNodeTypeMap];
